<template>
  <div>
    <div class="notification-bar text-center beware-bar" style="background:#2e2e2e;">
        <a href="/announcements" target="_blank">Beware of any Telegram groups, WhatsApp groups, unauthorized websites or unverified apps, pretending to be Shoonya ></a>
    </div>
    <div class="notification-bar text-center">
        <!-- <p class="mb-0 p-1"><b>Coming Soon!</b> AI-Powered Stock Research for Shoonya Users<a href="/ai-stock-trading" class="fin_btn brownBG">Sign Up</a></p> -->
        <!-- <p class="mb-0 p-1">AI-powered Predictive Analytics for Stock Market <a href="/ai-stock-trading" class="fin_btn brownBG">Try Now</a></p> -->
        <p class="mb-0 p-1">
        Data-Powered Signal Based Analysis for Stock Market
        <a href="https://shoonya.com/ai-stock-trading" target="_blank" class="fin_btn brownBG">Try Now</a></p>
    </div>
    <header class="mainHeader-section">
        <section class="phonenumberMob d-none"><p>+91 9098 001 001</p></section>
        <nav class="navbar navbar-expand-md navbar-light">
            <div class="container-fluid">
                <router-link class="navbar-brand headerLogo hideHover-ad" to="/"><img src="../../../../static/website/images/shoonya_logo.png" alt="Shoonya" title="Shoonya" width="150" height="53" /></router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar" aria-controls="collapsibleNavbar" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span><span class="navbar-toggler-icon close"></span>
                </button>
                <div class="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul class="navbar-nav ml-auto mt-1">
                        <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="#" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Products</router-link>
                            <div class="dropdown-menu fadeIn first" aria-labelledby="navbarDropdown">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <div class="navDropdownTextHeading">
                                                Products<br />
                                                We Offer
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <router-link class="dropdown-item" to="/trading"><span class="menuIcon ico1"></span>Trading<span>Invest with the Best</span></router-link>
                                            <router-link class="dropdown-item" to="/mutual-funds"><span class="menuIcon ico3"></span>Mutual Funds<span>Step into the Future</span></router-link>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <router-link class="dropdown-item" to="/clearing-services"><span class="menuIcon ico5"></span>Clearing Service<span>Settlement with Satisfaction</span></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link dropdown-toggle" to="#" id="navbardrop" data-toggle="dropdown">Tools</router-link>
                            <div class="dropdown-menu fadeIn">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12 col-md-3">
                                            <div class="navDropdownTextHeading">
                                                Trade<br />
                                                Anytime
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <router-link class="dropdown-item" to="/shoonya-trading-platform"><span class="menuIcon ico60"></span>Shoonya Trading Platform<span>Multi asset platform</span></router-link>
                                            <router-link class="dropdown-item" to="/calculators"><span class="menuIcon ico11"></span>Calculator<span>Know what you pay</span></router-link>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <router-link class="dropdown-item" to="/api"><span class="menuIcon ico10"></span>APIs<span>Automate your Trading</span></router-link>
                                            <router-link class="dropdown-item" to="/download"><span class="menuIcon ico12"></span>Downloads<span>Forms and documents</span></router-link>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <router-link class="dropdown-item" to="/fund-transfer"><span class="menuIcon ico15"></span>Funds Transfer<span>NSE/BSE/MCX/NCDEX</span></router-link>
                                            <router-link class="dropdown-item" to="/ai-stock-trading"><span class="menuIcon ico5"></span>AI Stock Trading<span>Stock Prediction</span></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item without-dropown">
                            <a class="nav-link noHover" href="/pricing">Pricing</a>
                            <div class="dropdown-menu fadeIn" style="display: none !important;">
                                <div class="container">
                                    <div class="row align-items-center justify-content-center">
                                        <div class="col-12 col-md-10 text-center ml-5">
                                            <div class="ftImg ftImg d-inline-flex text-center align-items-center">
                                                <div class="firstArea">
                                                    <div class="navDropdownTextHeadingPricing">brokerage on all<span>trading segments</span></div>
                                                </div>
                                                <div class="firstArea ml-5">
                                                        <span class="customBtn-bt"><router-link to="/pricing" class="fin_btn brownBG hideLink-hover px-4">Check our pricing</router-link></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- </li> -->
                        <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="#" id="navbardrop" data-toggle="dropdown">Investor Type</router-link>
                            <div class="dropdown-menu fadeIn">
                                <div class="container">
                                    <div class="row align-items-center">
                                        <div class="col-12 col-md-10 text-center ml-5">
                                            <div class="investorImg-head d-inline-flex text-center align-items-center w-100">
                                                <div class="firstArea investerText d-flex justify-content-end">
                                                    <div class="navDropdownTextHeadingInvester">
                                                        <span class="customBtn-bt"><router-link to="/retail-investors" class="fin_btn brownBG hideLink-hover">Retail</router-link></span>
                                                        <span class="customBtn-bt"><router-link to="/nri" class="fin_btn brownBG hideLink-hover">NRIs</router-link></span>
                                                        <span class="customBtn-bt"><router-link to="/fpi" class="fin_btn brownBG hideLink-hover">FPIs</router-link></span>
                                                        <span class="customBtn-bt"><router-link to="/hni" class="fin_btn brownBG hideLink-hover px-4">HNIs</router-link></span>
                                                    </div>
                                                </div>
                                                <div class="firstArea investerType-menu"><img class="img-fluid" src="../../../../static/website/images/5240.svg" alt="Image" width="420" height="210" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="#" id="navbardrop" data-toggle="dropdown">Company</router-link>
                            <div class="dropdown-menu fadeIn">
                                <div class="container">
                                    <div class="row align-items-center forMob">
                                        <div class="col-12 col-md-3">
                                            <div class="customBtn-bt mb-2"><router-link to="/about" class="fin_btn brownBG hideLink-hover">About Us</router-link></div>
                                            <div class="customBtn-bt mb-2"><router-link to="/contact-us" class="fin_btn brownBG hideLink-hover">Contact Us</router-link></div>
                                            <div class="customBtn-bt mb-2"><router-link to="/news" class="fin_btn brownBG hideLink-hover">News</router-link></div>
                                            <div class="customBtn-bt mb-2"><router-link to="/announcements" class="fin_btn brownBG hideLink-hover">Announcements</router-link></div>
                                            <div class="customBtn-bt"><router-link to="/faqs" class="fin_btn brownBG hideLink-hover">FAQs</router-link></div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <div class="callUs-mega pl-3">
                                                <div class="text-white"><phone-icon size="1.5x" style="display: initial;" class="custom-class"></phone-icon> Any Enquiry?</div>
                                                <div style="display: flex;">
                                                    <div>
                                                        <p style="font-size: 12px;">Sales:</p>    
                                                    </div>
                                                    <div>
                                                        <p>
                                                            <a style="display: block;font-size: 12px;" href="tel:+918288826999">+91 8288 826 999(New)</a>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div style="display: flex;">
                                                    <div>
                                                        <p style="font-size: 12px;">Support:</p>    
                                                    </div>
                                                    <div>
                                                        <p>
                                                            <a style="display: block;font-size: 12px;" href="tel:+919779902002">+91 9779 902 002(New)</a>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div style="display: flex;">
                                                    <div>
                                                        <p style="font-size: 12px;">Call & Trade:</p>    
                                                    </div>
                                                    <div>
                                                        <p>
                                                            <a style="display: block;font-size: 12px;" href="tel:+918699987666">+91 8699 987 666</a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3 p-lg-0">
                                            <div class="callUs-mega snd">
                                                <div class="text-white"><mail-icon style="display: initial;" size="1.5x" class="custom-class"></mail-icon> Mail us!</div>
                                                <p>Sales:<a href="mailto:contactus@shoonya.com">contactus@shoonya.com</a></p>
                                                <p>Support:<a href="mailto:clientsupport@shoonya.com">clientsupport@shoonya.com</a></p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <div class="callUs-mega trd">
                                                <div class="text-white"><home-icon size="1.5x" style="display: initial;" class="custom-class"></home-icon> Visit Us!</div>
                                                <p>Finvasia Centre D 179, Sector 74, Mohali Punjab 160055</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item without-dropown blogLink_H"><a class="nav-link" href="https://blog.shoonya.com/" target="_blank">Blog</a></li>
                        <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="#" id="navbardrop" data-toggle="dropdown">Login</router-link>
                            <div class="dropdown-menu fadeIn">
                                <div class="container">
                                    <div class="row align-items-center pt-3">
                                        <div class="col-12 col-md-3">
                                            <div class="pt-0 navDropdownTextHeading">
                                                Login<br />
                                                Anywhere
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-9 multiloginsoft d-flex align-items-center justify-content-center">
                                            <div class="loginMenu text-center">
                                                <a href="https://prism.shoonya.com/" target="_blank">
                                                    <span class="circleAdd"><img class="inBG img-fluid" alt="Prism" title="Prism Image" width="76" height="40" src="../../../../static/website/images/prismLogo-1-w.webp" /></span>Prism
                                                    <span class="d-block">&nbsp;</span>
                                                </a>
                                            </div>
                                            <div class="loginMenu text-center">
                                                <a href="https://trade.shoonya.com/" target="_blank">
                                                    <span class="circleAdd"><img class="inBG img-fluid" alt="Shoonya" title="Shoonya Image" width="43" height="40" src="../../../../static/website/images/shoonyaloginlogo.webp" /></span>
                                                    Shoonya<span class="d-block">&nbsp;</span>
                                                </a>
                                            </div>
                                            <div class="loginMenu text-center">
                                                <a href="https://backoffice.shoonya.com/CAP/index.jsp" target="_blank">
                                                    <span class="circleAdd"><img class="inBG img-fluid" alt="Back Office" title="Back Office Image" width="42" height="40" src="../../../../static/website/images/backoffice.svg" /></span>Back
                                                    Office<span class="d-block">&nbsp;</span>
                                                </a>
                                            </div>
                                            <div class="loginMenu text-center">
                                                <a href="https://reports.shoonya.com" target="_blank">
                                                    <span class="circleAdd"><img class="inBG img-fluid" alt="Back Office" title="Back Office Image" width="42" height="40" src="../../../../static/website/images/backoffice.svg" /></span>Back
                                                    Office<span class="d-block">(FY: 2022-2023)</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="nav-item dropdown account"><a class="nav-link btn-6"  @click.prevent="handleWebEngageEvent" style="cursor: pointer;">Open an Account</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
    <div v-if="showModal" class="vue-modal-overlay">
          <div class="vue-modal-content scan-modal">
          <div class="scan-modal-left">
            <button class="close-btn" @click="showModal = false">
                <img src="../../../../static/website/images/cross-icon.svg" alt="Close" />
             </button>
            <!-- <h2 class="scan-title">Scan to Open an Account</h2> -->
            <div class="qr-wrapper">
            <img
                src="../../../../static/website/images/live-qr.svg"
                alt="Scan to install Shoonya App"
                class="qr-image"
                width="250"
                height="250"
            />
            </div>
            <div class="app-links">
                <div class="store-card" @click="redirectToAndroidStore" style="cursor: pointer;">
                    <img src="../../../../static/website/images/google-play.png" alt="Google Play" class="store-icon" />
                    <div class="store-text">
                    <span class="store-title">Google Play</span>
                    <span class="store-rating">4.5 <span class="star"><img src="../../../../static/website/images/star.svg"  class="star-icon" /></span></span>
                    </div>
                </div>
                <div class="store-card"  @click="redirectToIphoneStore" style="cursor: pointer;">
                    <img src="../../../../static/website/images/app-store.png" alt="App Store" class="store-icon" />
                    <div class="store-text">
                    <span class="store-title">App Store</span>
                    <span class="store-rating">4.5 <span class="star"><img src="../../../../static/website/images/star.svg"  class="star-icon" /></span></span>
                    </div>
                </div>
            </div>
          </div>
          <div class="scan-modal-right">
            <div class="scan-modal-right-container">
              <h1 class="scan-modal-right-title">Start Your Investment Journey with Shoonya</h1>

              <div class="scan-modal-right-steps">
                <!-- Step 1 -->
                <div class="scan-modal-right-step">
                  <img src="../../../../static/website/images/radio-step.svg" alt="dots" class="scan-modal-right-step-icon" />
                  <div class="scan-modal-right-step-content">
                    <div class="scan-modal-right-step-label">STEP 1</div>
                    <div class="scan-modal-right-step-text">Scan the QR to Get the App</div>
                  </div>
                </div>

                <!-- Connector Line -->
                <div class="scan-modal-right-step-connector"></div>

                <!-- Step 2 -->
                <div class="scan-modal-right-step">
                  <img src="../../../../static/website/images/radio-step.svg" alt="dots" class="scan-modal-right-step-icon" />
                  <div class="scan-modal-right-step-content">
                    <div class="scan-modal-right-step-label">STEP 2</div>
                    <div class="scan-modal-right-step-text">Tap "Register Now”</div>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="scan-modal-right-footer">
                <span>Need Help?</span>
                <a href="https://www.youtube.com/watch?v=4KXEe_2mFRI" target="_blank" class="scan-modal-right-see-link">
                  <span class="scan-modal-right-play-icon"><img src="../../../../static/website/images/play-youtube-icon.svg"/></span>
                  <span>Learn How It Works</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        </div>
</div>

</template>
<script>
import { PhoneIcon } from "vue-feather-icons";
import { MailIcon } from "vue-feather-icons";
import { HomeIcon } from "vue-feather-icons";
export default {
  name: "Header",
  data() {
    return {
      prismLoginPath: process.env.PRISM_LOGIN,
      prismRegisterPath: process.env.PRISM_REGISTER,
      backOfficeLoginPath: process.env.BACKOFFICE_LOGIN,
      showModal: false,
    };
  },
  components: {
    PhoneIcon,
    MailIcon,
    HomeIcon,
  },
  mounted() {
    $(function () {
      $("ul.navbar-nav li").hover(
        function () {
          $(".mainHeader-section").addClass("hover");
        },
        function () {
          $(".mainHeader-section").removeClass("hover");
        }
      );

      $("ul.navbar-nav li.without-dropown").hover(
        function () {
          $(".mainHeader-section").removeClass("hover");
        }
      );

      $("ul.navbar-nav li.nav-item.dropdown.account").hover(
        function () {
          $(".mainHeader-section").addClass("hoverHide");
        },
        function () {
          $(".mainHeader-section").removeClass("hoverHide");
        }
      );
    });
    // if (window.innerWidth > 767) {
    //    $("li.nav-item.dropdown").hover(
    //       function () { setTimeout(function(){
    //           $('.dropdown-menu.fadeIn').addClass("display-on");
    //         }, 200);

    //       },
    //       function () {
    //         $('.dropdown-menu.fadeIn').removeClass("display-on");

    //       }
    //     );
    //    }
    $(".dropdown-item").click(function () {
      $("header").removeClass("hover");
      $(".dropdown-menu").removeClass("display-on");
    });
    $(".hideLink-hover").click(function () {
      $("header").removeClass("hover");
    });

    $(".navbar-toggler").click(function () {
      $(".mainHeader-section").toggleClass("blackHeader");
    });
  },
  methods: {
    handleWebEngageEvent() {
          const isMobile = window.matchMedia("(max-width: 768px)").matches;

        if (isMobile) {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

               const isSafariMobile = /^((?!chrome|android).)*safari/i.test(userAgent) && /iPad|iPhone|iPod/.test(userAgent);
                const isAndroidMobile = /android/i.test(userAgent);
              

                if (isSafariMobile) {
                    // Mobile Safari (iOS)
                    window.open("https://apps.apple.com/in/app/shoonya/id1539034076", "_blank");
                } else if (isAndroidMobile) {
                    // Android (Chrome or other browser)
                    window.open("https://play.google.com/store/apps/details?id=com.rs.shoonya&hl=en", "_blank");
                } else {
                    // Default fallback (other mobile browsers)
                    window.open("/", "_blank");
                }
            } else {
                this.showModal = true;
                console.log("Function called from desktop view.");
            }
            webengage.track("Open An Account", {"Value": "Yes"});   
            // window.open("https://prism.shoonya.com/register", "_blank");
        },  

        redirectToAndroidStore() {
            window.open("https://play.google.com/store/apps/details?id=com.rs.shoonya&hl=en");
          
        },
        redirectToIphoneStore() {
            window.open("https://apps.apple.com/in/app/shoonya/id1539034076");
            
        }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/website/shared/header.vue